import type { QueryClient } from "@tanstack/react-query";

/**
 * Czyści sessionStorage cache feedu strony głównej (`index:feed:*`).
 * Wywołaj po operacjach które zmieniają widoczność koszulek
 * (usunięcie, zmiana is_public), żeby powrót na home wymusił świeży pobór.
 *
 * Jeśli przekażesz `queryClient`, dodatkowo unieważnia cache React Query
 * dla zapytań strony głównej / eksploracji — następne wejście pobierze świeże dane
 * bez konieczności przeładowywania strony.
 */
export function clearHomeFeedCache(queryClient?: QueryClient): void {
  try {
    for (let i = sessionStorage.length - 1; i >= 0; i--) {
      const key = sessionStorage.key(i);
      if (
        key &&
        (key.startsWith("index:feed:") || key.startsWith("collection:feed:"))
      ) {
        sessionStorage.removeItem(key);
      }
    }
  } catch {
    /* ignore */
  }

  if (queryClient) {
    try {
      queryClient.invalidateQueries({ queryKey: ["index-home"] });
      queryClient.invalidateQueries({ queryKey: ["top-kits"] });
      queryClient.invalidateQueries({ queryKey: ["explore-kits"] });
      queryClient.invalidateQueries({ queryKey: ["for-sale-kits"] });
    } catch {
      /* ignore */
    }
  }
}
